import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FrontSiteRoutes } from "@routes/urls";
import { Link } from "react-router-dom";
import { Segment, Header, Button, Container, Tab } from "semantic-ui-react";
import DocumentAuthors from "@modules/Document/DocumentAuthors";
import { invenioConfig } from "@config";
import _get from "lodash/get";

const SummaryPane = () => null;
SummaryPane.displayName = "SummaryPane";

const CardPane = () => null;
CardPane.displayName = "CardPane";

const LoanRequestSummary = ({ formData, onGoBack, document }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const docData = document || formData.document || {};
  const authors = _get(docData, "metadata.authors", []);
  const hasOtherAuthors = _get(docData, "metadata.other_authors", false);

  const renderAuthorsBackup = () => {
    if (Array.isArray(authors) && authors.length > 0) {
      return authors.map((author, index) => (
        <span key={index}>
          {author.full_name || author.name}
          {index < authors.length - 1 ? ", " : ""}
        </span>
      ));
    }
    return formData.author || "(No author information available)";
  };

  const containerStyles = {
    maxWidth: isMobile ? "95%" : "100px",
    margin: "0 auto",
    padding: isMobile ? "0 10px" : "0",
  };

  const segmentStyles = {
    margin: isMobile ? "10px 0" : "-10px -5px",
    padding: isMobile ? "30px 20px" : "40px 50px",
    border: "6px solid #2C6E49",
    borderRadius: "10px",
    boxShadow: "none",
  };

  const headerStyles = {
    color: "#2C6E49",
    marginBottom: isMobile ? "20px" : "30px",
    fontSize: isMobile ? "18px" : "20px",
    textAlign: "center",
  };

  const sectionHeaderStyles = {
    fontSize: isMobile ? "16px" : "18px",
    marginBottom: "20px",
    textAlign: "left",
    color: "#2C6E49",
    fontWeight: "600",
  };

  const infoRowStyles = {
    display: "flex",
    marginBottom: "12px",
    textAlign: "left",
  };

  const labelStyles = {
    fontWeight: "600",
    minWidth: "140px",
    color: "#333",
  };

  const valueStyles = {
    color: "#555",
    flex: 1,
  };

  const renderBorrowerInfo = () => (
    <div style={{ marginBottom: "30px" }}>
      <Header as="h4" style={sectionHeaderStyles}>
        Borrower Information
      </Header>
      <div>
        <div style={infoRowStyles}>
          <span style={labelStyles}>Name:</span>
          <span style={valueStyles}>
            {formData.firstName} {formData.lastName}
          </span>
        </div>
        <div style={infoRowStyles}>
          <span style={labelStyles}>Contact:</span>
          <span style={valueStyles}>{formData.contactNo}</span>
        </div>
        <div style={infoRowStyles}>
          <span style={labelStyles}>College:</span>
          <span style={valueStyles}>{formData.college}</span>
        </div>
        <div style={infoRowStyles}>
          <span style={labelStyles}>Program:</span>
          <span style={valueStyles}>{formData.program}</span>
        </div>
        <div style={infoRowStyles}>
          <span style={labelStyles}>Year:</span>
          <span style={valueStyles}>{formData.year}</span>
        </div>
      </div>
    </div>
  );

  const renderDocumentInfo = () => (
    <div style={{ marginBottom: "30px" }}>
      <Header as="h4" style={sectionHeaderStyles}>
        Document Information
      </Header>
      <div>
        <div style={infoRowStyles}>
          <span style={labelStyles}>Title:</span>
          <span style={valueStyles}>{formData.title}</span>
        </div>
        <div style={infoRowStyles}>
          <span style={labelStyles}>Author(s):</span>
          <span style={valueStyles}>
            {Array.isArray(authors) && authors.length > 0 ? (
              <DocumentAuthors
                authors={authors}
                hasOtherAuthors={hasOtherAuthors}
                prefix=""
                limit={invenioConfig.LITERATURE.authors.maxDisplay}
              />
            ) : (
              renderAuthorsBackup()
            )}
          </span>
        </div>
        <div style={infoRowStyles}>
          <span style={labelStyles}>Checkout Date:</span>
          <span style={valueStyles}>{formData.checkOutDate}</span>
        </div>
        <div style={infoRowStyles}>
          <span style={labelStyles}>Due Date:</span>
          <span style={valueStyles}>{formData.dueDate}</span>
        </div>
        <div style={infoRowStyles}>
          <span style={labelStyles}>Use Type:</span>
          <span style={valueStyles}>
            {formData.homeUse
              ? "Home Use"
              : formData.libraryUse
              ? "Library Use"
              : "Not specified"}
          </span>
        </div>
      </div>
    </div>
  );

  const buttonStyles = {
    backgroundColor: "#2C6E49",
    color: "white",
    padding: isMobile ? "10px 20px" : "12px 30px",
    fontSize: isMobile ? "14px" : "15px",
    borderRadius: "4px",
    margin: isMobile ? "10px 5px" : "0 10px",
    cursor: "pointer",
  };

  const backButtonStyles = {
    backgroundColor: "#f1f1f1",
    color: "#333",
    padding: isMobile ? "10px 20px" : "12px 30px",
    fontSize: isMobile ? "14px" : "15px",
    borderRadius: "4px",
    margin: isMobile ? "10px 5px" : "0 10px",
    cursor: "pointer",
  };

  SummaryPane.displayName = "SummaryPane";
  function SummaryPaneComponent() {
    return (
      <div style={{ padding: isMobile ? "10px" : "20px" }}>
        {renderBorrowerInfo()}
        {renderDocumentInfo()}
      </div>
    );
  }

  function CardPaneComponent() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        {" "}
      </div>
    );
  }

  function renderSummaryPane() {
    return <SummaryPaneComponent />;
  }

  function renderCardPane() {
    return <CardPaneComponent />;
  }

  const panes = [
    { menuItem: "Summary", render: renderSummaryPane },
    { menuItem: "Card", render: renderCardPane },
  ];

  if (isMobile) {
    return (
      <Container style={containerStyles}>
        <Segment style={segmentStyles}>
          <Header as="h2" style={headerStyles}>
            Loan Request Summary
          </Header>
          <Tab
            menu={{ secondary: true, pointing: true, widths: panes.length }}
            panes={panes}
          />
          <div style={{ textAlign: "center", marginTop: "30px" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Link
                to={{
                  pathname: FrontSiteRoutes.patronProfile,
                  state: { focusTab: "activity" },
                }}
              >
                <Button style={buttonStyles}>View All Loans</Button>
              </Link>
              <Button style={backButtonStyles} onClick={onGoBack}>
                Back to Document
              </Button>
            </div>
          </div>
        </Segment>
      </Container>
    );
  }

  return (
    <Container style={containerStyles}>
      <Segment style={segmentStyles}>
        <Header as="h2" style={headerStyles}>
          Loan Request Summary
        </Header>

        {renderBorrowerInfo()}
        {renderDocumentInfo()}

        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <Link
            to={{
              pathname: FrontSiteRoutes.patronProfile,
              state: { focusTab: "activity" },
            }}
          >
            <Button style={buttonStyles}>View All Loans</Button>
          </Link>

          <Button style={backButtonStyles} onClick={onGoBack}>
            Back to Document
          </Button>
        </div>
      </Segment>
    </Container>
  );
};

LoanRequestSummary.propTypes = {
  formData: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    contactNo: PropTypes.string,
    college: PropTypes.string,
    program: PropTypes.string,
    year: PropTypes.string,
    title: PropTypes.string,
    author: PropTypes.string,
    checkOutDate: PropTypes.string,
    dueDate: PropTypes.string,
    homeUse: PropTypes.bool,
    libraryUse: PropTypes.bool,
    document: PropTypes.object,
  }).isRequired,
  document: PropTypes.shape({
    metadata: PropTypes.shape({
      authors: PropTypes.array,
      other_authors: PropTypes.bool,
    }),
  }),
  onGoBack: PropTypes.func.isRequired,
};

export default LoanRequestSummary;
